module.exports = "/images/veil-11.jpg";